import React, {Component} from 'react';
import Main from '../../components/smart/Main';
import MainMessage from '../../components/smart/MainMessage';
import Logo from './../Logo.png';


class AboutPage extends Component {
    render() {
        return (
                <Main Title=" " Description=" ">
                    <MainMessage>
                        <div className="Main_Message_Content">
                            <p>
                                Matrix Healthcare continues to extend its resources to employers looking for a win-win solution for the employer, employee, and professional provider.
                                We offer self-funded and fully-insured dental plan options, as well as an open network vision reimbursement plan.
                                Matrix Healthcare provides flexibility that allows our clients to obtain uniquely designed dental & vision benefit packages that fit the needs of their organizations.
                                We can provide guidance on plan design options involving the most up-to-date dental procedures and guidelines.
                                We pride ourselves on having long-term relationships with each of our clients.
                            </p>
                        </div>
                        <div className="Main_Message_Logo_Box">
                            <img src={Logo} alt="Logo"></img>
                        </div>
                    </MainMessage>
                </Main>                
        )
    }
}

export default AboutPage;